import config from '../../../../config'

import {
    ADD_GROUP_TO_ENTITY_STACK,
    CHANGE_ENTITY_STACK_GROUP_DATA,
    CHANGE_ENTITY_STACK_GROUP_MEMBERS,
    TOGGLE_GROUP_STACK,
    CREATE_GROUP_REQUEST,
    UPDATE_GROUP_REQUEST,
    LOAD_GROUP_MEMBERS,
    LOAD_GROUP_MEMBERS_REQUEST,
    INSERT_MEMBER_TO_GROUP_REQUEST,
    SETUP_GROUP_STACK,
    CREATE_NEW_GROUP,
    INITIALIZE_GROUP_STACK,
    CHANGE_GROUP_NAME,
    CHANGE_GROUP_NAME_REQUEST,
    DELETE_GROUP_MEMBER,
    DELETE_GROUP_MEMBER_REQUEST,
    CHANGE_MEMBERS_PER_PAGE,
    DELETE_ALL_GROUP_MEMBERS,
    DELETE_ALL_GROUP_MEMBERS_REQUEST,
    RESIZE_GROUP_STACK,
    INSERT_MEMBER_TO_GROUP,
    GROUP_STACK_NAME_BEING_EDITED,
    GROUP_STACK_EXPORT_MEMBERS,
    GROUP_STACK_FILTER_GET_MEMBERS_REQUEST,
} from './constants'

export function insertMemberToGroup(groupId, memberId) {
    return {
        type: INSERT_MEMBER_TO_GROUP,
        data: {
            groupId,
            memberId,
        },
    }
}

export function insertMemberToGroupRequest(groupId, memberId, sessionId) {
    return {
        type: INSERT_MEMBER_TO_GROUP_REQUEST(groupId),
        payload: {
            uri: config.api.entityStack.groups.insertToGroup.uri,
            method: config.api.entityStack.groups.insertToGroup.method,
            formData: `group_id=${encodeURIComponent(groupId)}&m=${encodeURIComponent(memberId)}`,
            headers: {
                sid: sessionId,
                Accept: 'text/plain ',
                'content-type': 'application/x-www-form-urlencoded',
            },
        },
    }
}

export function changeGroupName(groupName, groupId) {
    return {
        type: CHANGE_GROUP_NAME,
        data: {
            groupName,
            groupId,
        },
    }
}

export function changeGroupNameRequest(groupName, groupId) {
    return {
        type: CHANGE_GROUP_NAME_REQUEST,
        payload: {
            ...config.api.groupStack.changeGroupName,
            qs: {
                id: groupId,
            },
            body: {
                name: groupName,
            },
        },
    }
}

export function createGroupRequest(groupName) {
    return {
        type: CREATE_GROUP_REQUEST,
        payload: {
            ...config.api.groupStack.createGroup,
            body: {
                name: groupName,
            },
        },
    }
}

export function deleteGroupMember(groupId, memberId) {
    return {
        type: DELETE_GROUP_MEMBER,
        data: {
            groupId,
            memberId,
        },
    }
}

export function deleteGroupMemberRequest(groupId, memberId) {
    return {
        type: DELETE_GROUP_MEMBER_REQUEST(groupId),
        payload: {
            ...config.api.groupStack.deleteGroupMember,
            qs: {
                id: groupId,
                memberId,
            },
        },
    }
}

export function deleteAllGroupMembers(groupId) {
    return {
        type: DELETE_ALL_GROUP_MEMBERS,
        data: {
            groupId,
        },
    }
}

export function deleteAllGroupMembersRequest(groupId) {
    return {
        type: DELETE_ALL_GROUP_MEMBERS_REQUEST,
        payload: {
            ...config.api.groupStack.deleteAllGroupMembers,
            qs: {
                id: groupId,
            },
        },
    }
}

export const updateGroupName = (nextGroupName, userId) => ({
    type: UPDATE_GROUP_REQUEST,
    payload: {
        ...config.api.groupStack.createGroup,
        qs: { id: userId },
        body: { name: nextGroupName },
    },
})

export function loadGroupMembers(groupId, page, rows = 10) {
    return {
        type: LOAD_GROUP_MEMBERS,
        data: {
            groupId,
            page,
            rows,
        },
    }
}

export function loadGroupMembersRequest(groupId, page = 0, rows = 10) {
    return {
        type: LOAD_GROUP_MEMBERS_REQUEST,
        payload: {
            ...config.api.groupStack.loadGroupMembers,
            qs: {
                id: groupId,
                page,
                rows,
            },
        },
    }
}

export function changeMembersPageLimit(nextMembersCount) {
    return {
        type: CHANGE_MEMBERS_PER_PAGE,
        data: {
            nextMembersCount,
        },
    }
}

export function addGroupToEntityStack(data) {
    return {
        type: ADD_GROUP_TO_ENTITY_STACK,
        data: {
            data,
        },
    }
}

export function setupGroupStack(groupId, groupData) {
    return {
        type: SETUP_GROUP_STACK,
        data: {
            groupId,
            groupData,
        },
    }
}

export function createNewGroup(groupId, groupName) {
    return {
        type: CREATE_NEW_GROUP,
        data: {
            groupId,
            groupName,
        },
    }
}

export function initializeGroupStack(groupId) {
    return {
        type: INITIALIZE_GROUP_STACK,
        data: {
            groupId,
        },
    }
}

export function toggleGroupStack(groupId, groupName) {
    return {
        type: TOGGLE_GROUP_STACK,
        data: {
            groupId,
            groupName,
        },
    }
}

export function changeEntityStackGroupData(data) {
    return {
        type: CHANGE_ENTITY_STACK_GROUP_DATA,
        data: {
            data,
        },
    }
}

export function changeEntityStackGroupMembers(groupId, membersCount) {
    return {
        type: CHANGE_ENTITY_STACK_GROUP_MEMBERS,
        data: {
            groupId,
            membersCount,
        },
    }
}

export function resizeGroupStack(nextSize) {
    return {
        type: RESIZE_GROUP_STACK,
        data: {
            size: nextSize,
        },
    }
}

export function groupStackChangeNameBeingEdited(value) {
    return {
        type: GROUP_STACK_NAME_BEING_EDITED,
        data: {
            value,
        },
    }
}

export function groupStackExportMembers(groupId, groupName) {
    return {
        type: GROUP_STACK_EXPORT_MEMBERS,
        data: {
            groupId,
            groupName,
        },
    }
}

export function groupStackFilterGetMembersRequest(groupId, query, page, rows, lang, sid) {
    return {
        type: GROUP_STACK_FILTER_GET_MEMBERS_REQUEST,
        payload: {
            ...config.api.groupStack.filterGetMembers,
            qs: {
                group_id: groupId,
                filterMemberNamesBy: query,
                page,
                rows,
                lang,
            },
            headers: {
                sid,
            },
        },
    }
}
